module.exports = __webpack_public_path__ + "img/json.f5a897f4.png";